export const ALLOW_CREATIVES_VIA_BIDSTREAM_LABEL = 'Allow creatives via the Bidstream';
export const CREATIVES_SUBMITTED_VIA_BIDSTREAM_CHIP = 'Creatives submitted via the Bidstream';
export const DSP_SETTINGS_SECTION_LABEL = 'DSP Settings';
